import { call, put } from 'redux-saga/effects';
import REMOTE_STATUS_ACTION from '../actionTypes/UpdateRemoteSubscription';
import UpdateRemoteSubscription from '../apis/UpdateRemoteSubscription';

/**
 * @name get updated remote subscription
 * @description get updated remote subscription status
 * @note  will use commented code for future sprint work to check the vehicle capability
 */

export function* getUpdatedRemoteStatus() {
  try {
    const response = yield call(UpdateRemoteSubscription.get);
    const payload = response || {};
    let flag = false;
    if (response.status === 'complete') {
      flag = true;
    }
    yield put({
      type: REMOTE_STATUS_ACTION.REMOTE_SUBSCRIPTION_SUCCESS,
      payload: flag,
    });
  } catch (error) {
    yield put({
      type: REMOTE_STATUS_ACTION.REMOTE_SUBSCRIPTION_ERROR,
      error,
    });
  }
}
